// Assets every document links from the root route's head (src/routes/__root.tsx).
import themeCss from "shared-web/theme.css?url";
import fontsCss from "../fonts.scss?url";
import globalsCss from "../globals.scss?url";

/**
 * The root stylesheets, in cascade order. fonts.scss is its own stylesheet: globals.scss is rebuilt
 * whenever Tailwind sees a source change, and re-adding @font-face rules makes text fall back and
 * swap again (a visible font flash).
 */
export const ROOT_STYLESHEETS = [themeCss, fontsCss, globalsCss];

/**
 * Fonts every page paints first: body text and headings (the Latin subsets of Inter and Satoshi).
 * Preloading them starts the downloads with the HTML instead of after the stylesheet (see
 * src/fonts.scss, whose @font-face rules must name these same files).
 */
export const FONT_PRELOADS = [
  "/fonts/inter/inter-latin-v1.woff2",
  "/fonts/satoshi/satoshi-latin-v1.woff2",
];
